/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class TimePickerMeridiem extends React.Component {
    constructor(props) {
        super(props);

        this.changeHandler = this.changeHandler.bind(this);

    }

    changeHandler(e) {

        let ret = e.currentTarget.value;

        e.preventDefault();

        this.props.changeHandler(ret, e);

    }

    shouldComponentUpdate(nextProps, nextState) {

        if (nextProps.scheduleTime !== undefined && (this.props.scheduleTime !== undefined && this.props.scheduleTime !== null)) {
            if (nextProps.scheduleTime.format('A') == this.props.scheduleTime.format('A')) {
                return false;
            }
        }

        return true;

    }

    render() {

        let time = moment(this.props.scheduleTime),
            meridiem = time.format('A'),
            meridiems = ['AM', 'PM'],
            meridiemOptions = meridiems.map((val, i) => {
                return (
                    <option value={val} key={'mer-' + this.props.scheduleTime + '-' + val}>{val}</option>
                );
            });

        return (
            <select className="dlvr-select time-picker" value={meridiem} onChange={this.changeHandler} data-field="meridiem">
                {meridiemOptions}
            </select>
        );

    }

};

TimePickerMeridiem.displayName = "TimePickerMeridiem";

TimePickerMeridiem.propTypes = {
    scheduleTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    changeHandler: PropTypes.func
};

TimePickerMeridiem.defaultProps = {
    scheduleTime: moment().toISOString(),
    changeHandler: null
};

export default TimePickerMeridiem;
